import invitationcodes from "./invitationcodes"


export default {
	modules: {
		invitationcodes
	},
	strict: true,
	namespaced: true,
}